










































































import Vue from "vue";
import {buildAuthorizationUrl, generateState, getOAuthConfig} from "../scripts/helpers/socialAuth/oauth";
import {generateOAuthSecurityParams, storePKCEVerifier} from "../scripts/helpers/socialAuth/pkce";
import { Trans } from "@/shared/scripts/helpers/translation/translation";

export default Vue.extend({
    props: {
        type: {
            type: String,
            required: false,
            default: "login"
        }
    },
    computed: {
        isEnabled: function(): boolean {
            const envEnabled = process.env.VUE_APP_MIX_ENABLE_SOCIAL_LOGINS === "true";
            const localStorageEnabled = localStorage.getItem("enable_social_login") === "true";
            return envEnabled || localStorageEnabled;
        },
        currentLocale: function(): string {
            return Trans.currentLocale || "en";
        }
    },
    methods: {
        authenticate: async function(provider: "apple" | "google") {
            const config = getOAuthConfig(provider);
            const { codeVerifier, codeChallenge, nonce } = await generateOAuthSecurityParams();
            const currentUrl = window.location.href;
            const homepageUrl = new URL(
                process.env.VUE_APP_IMMOWEB_URL
                    + "/"
                    + this.currentLocale
            );
            const redirectUri = currentUrl.includes("/login") ? homepageUrl.href : currentUrl;

            storePKCEVerifier({
                codeVerifier: codeVerifier,
                tokenEndpoint: config.tokenEndpoint,
                clientId: config.clientId,
                redirectUri: redirectUri,
                nonce: nonce,
                provider: provider,
                type: this.type
            });

            const state = generateState(provider, "sign-in");
            window.location.href = buildAuthorizationUrl(config, codeChallenge, state, nonce, provider);
        },
    }
});
